import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
    Text,
    View,
    TouchableOpacity
} from "react-native";
import WheelPicker from "./WheelPicker";
import {
    Str_Cancel,
    Str_Day,
    Str_Month, Str_Save,
    Str_SelectYourBirthday,
    Str_Year,
} from "../../language/string_res";

export type PickerSelectDate = {
    year: number
    month: number,
    day: number
}

interface DatePickerProp {
    defValue: string,
    minYear: number,
    onSelectYear?: (year: number) => void, // 年份选择器回调事件 返回：{year: ''}
    onSelectMonth?: ({ year, month }: { year: number, month: number }) => void, // 月份选择器回调事件 返回：{year: '', month: ''}
    onSelectDate?: ({ year, month, day }: { year: number, month: number, day: number }) => void,  // 日期选择器回调事件 返回：{year: '', month: '', date: ''}
    // 点击确定的回调事件
    // (date: Date) => void
    onComplete: (date: PickerSelectDate) => void
    onCancel: () => void
}


export const DatePicker = (props: DatePickerProp) => {
    const now = new Date();
    const nowYear = now.getFullYear();
    const nowMonth = now.getMonth() + 1;
    const nowDay = now.getDate();

    let curYear = nowYear;
    let curMonth = nowMonth
    let curDay = nowDay
    const split = props.defValue.split("/")
    if (split.length === 3) {
        const y = Number(split[0])
        const m = Number(split[1])
        const d = Number(split[2])
        if (y > 0) {
            curYear = y
        }
        if (m > 0) {
            curMonth = m
        }
        if (d > 0) {
            curDay = d
        }
    }

    const [state, setState] = useState<PickerSelectDate>({
        year: curYear,
        month: curMonth,
        day: curDay
    });

    const { yearList, monthList, dayList } = useMemo(() => {
        let yearList: number[] = [];
        let monthArr: number[] = [];
        let dayArr: number[] = [];

        for (let i = props.minYear; i <= nowYear; i++) {
            yearList.push(i);
        }
        if (state.year === nowYear) {
            for (let i = 1; i <= nowMonth; i++) {
                monthArr.push(i);
            }
        } else {
            monthArr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
        }
        if (state.year === nowYear && state.month === nowMonth) {
            for (let i = 0; i <= nowMonth; i++) {
                dayArr.push(i);
            }
        } else {
            let days = new Date(state.year, state.month, 0).getDate();
            dayArr = Array.from(new Array(days).keys());
        }
        return { yearList: yearList, monthList: monthArr, dayList: dayArr }
    }, [state])

    const handleYearChange = (year: number) => {
        setState({ ...state, year: year });
    };

    const handleMonthChange = (month: number) => {
        setState({ ...state, month: month });
    };

    const { onComplete, onCancel } = props;

    const _renderYear = useCallback(() => {
        const index = yearList.indexOf(curYear)
        return (
            <View style={{ flex: 1 }}>
                <WheelPicker
                    width={"100%"}
                    initialSelectedIndex={index !== -1 ? index : yearList.length - 1}
                    onChange={({ item }) => handleYearChange(item.value)}
                    items={yearList.map(item => ({
                        label: `${item}${Str_Year}`,
                        value: item
                    }))}
                />
            </View>
        );
    }, [yearList]);


    const _renderMonth = useCallback(() => {
        const index = monthList.indexOf(curMonth)
        return (
            <View style={{ flex: 1 }}>
                <WheelPicker
                    width={"100%"}
                    initialSelectedIndex={index !== -1 ? index : monthList.length - 1}
                    onChange={({ item }) => handleMonthChange(item.value)}
                    items={monthList.map(item => {
                        return {
                            label: `${item}${Str_Month}`,
                            value: item
                        };
                    })}
                />
            </View>
        );
    }, [monthList]);

    const _renderDay = useCallback(() => {
        const index = dayList.indexOf(curDay) - 1
        return (
            <View style={{ flex: 1 }}>
                <WheelPicker
                    width={"100%"}
                    initialSelectedIndex={index !== -1 ? index : dayList.length - 1}
                    onChange={({ item }) => {
                        setState({ ...state, day: item.value });
                    }}
                    items={dayList.map(item => ({
                        label: `${item + 1}${Str_Day}`,
                        value: item + 1
                    }))}
                />
            </View>
        );
    }, [dayList]);


    return (
        <View style={{
            backgroundColor: "#F6F6F6",
            borderTopStartRadius: 12,
            borderTopEndRadius: 12,
            paddingVertical: 26,
            paddingHorizontal: 10
        }}>
            <View style={{ flexDirection: "row", width: "100%", alignItems: "center", justifyContent: "center" }}>
                <TouchableOpacity
                    style={{ position: "absolute", start: 0, paddingVertical: 6, paddingHorizontal: 12 }}
                    onPress={onCancel}
                    children={
                        <Text style={{
                            fontSize: 17,
                            color: "#000000"
                        }}>{Str_Cancel}</Text>}
                />
                <Text
                    ellipsizeMode={'tail'} numberOfLines={1}
                    style={{
                        fontSize: 18,
                        color: "#2A2A2A",
                        fontWeight: "bold",
                        fontFamily: '',
                        flex: 1,
                        textAlign: 'center'
                    }}>{Str_SelectYourBirthday}</Text>
                <TouchableOpacity
                    style={{ position: "absolute", end: 0, paddingVertical: 6, paddingHorizontal: 12 }}
                    onPress={() => {
                        props.onSelectDate && props.onSelectDate({
                            year: state.year,
                            month: state.month,
                            day: state.day
                        });
                        props.onSelectMonth && props.onSelectMonth({
                            year: state.year,
                            month: state.month
                        });
                        props.onSelectYear && props.onSelectYear(state.year);
                        onComplete(state);
                    }}
                    children={
                        <Text style={{
                            fontSize: 17,
                            color: "#3478F5"
                        }}>{Str_Save}</Text>
                    }
                />
            </View>
            <View style={{
                flexDirection: "row",
                backgroundColor: "white",
                borderRadius: 12,
                marginTop: 24,
                paddingHorizontal: 40,
                paddingVertical: 20
            }}>
                {_renderYear()}
                {_renderMonth()}
                {_renderDay()}
            </View>
        </View>
    );
};
